import { DEFAULT_MONTHLY_RUN_ON, DEFAULT_TIME_SLOT, DEFAULT_WEEKLY_RUN_ON, SCHEDULE_FREQUENCY } from '../consts';
import type { ScheduleFrequency, ScheduleTimeSlot } from '../types';

/** Input of `getScheduleForFrequency`. */
interface Params {
  /** Frequency the user switched to. */
  frequency: ScheduleFrequency;
  /** Time slot selected before the switch. */
  timeSlot: ScheduleTimeSlot | null;
}

/**
 * Schedule values after the user switches frequency. Weekly and monthly get their default
 * day or date and keep the selected time slot; the other frequencies have neither.
 */
export const getScheduleForFrequency = ({ frequency, timeSlot }: Params) => {
  const scheduleTimeSlot = timeSlot ?? DEFAULT_TIME_SLOT;

  if (frequency === SCHEDULE_FREQUENCY.WEEKLY) {
    return { scheduleFrequency: frequency, scheduleRunOn: DEFAULT_WEEKLY_RUN_ON, scheduleTimeSlot };
  }

  if (frequency === SCHEDULE_FREQUENCY.MONTHLY) {
    return { scheduleFrequency: frequency, scheduleRunOn: DEFAULT_MONTHLY_RUN_ON, scheduleTimeSlot };
  }

  return { scheduleFrequency: frequency, scheduleRunOn: null, scheduleTimeSlot: null };
};
